/**
 * Seller (Bohringer Technik GmbH) constants for XRechnung
 */

import {PaymentMeans, SellerParty} from './types';

/**
 * Bohringer Technik GmbH seller information
 */
export const BOEHRINGER_SELLER: SellerParty = {
    name: 'Bohringer Technik GmbH',
    registrationName: 'Bohringer Technik GmbH',
    identification: {
        // TODO: Replace with actual VAT ID (USt-IdNr.)
        vatId: 'DE000000000',
        taxNumber: '65201/64287',
    },
    postalAddress: {
        streetName: 'Wilhelmstrasse 14',
        cityName: 'Heilbronn',
        postalZone: '74072',
        countryCode: 'DE',
    },
    contact: {
        telephone: '+49 7131 745700',
        email: 'info@boehringer.net',
    },
    companyId: 'HRB 760818',
};

/**
 * Bohringer Technik GmbH payment means
 */
export const BOEHRINGER_PAYMENT_MEANS: PaymentMeans = {
    // 58 = SEPA credit transfer
    paymentMeansCode: '58',
    iban: 'DE88620632630204263000',
    bic: 'GENODES1VLS',
    accountName: 'Bohringer Technik GmbH',
    financialInstitutionName: 'VBU Volksbank im Unterland eG',
};

/**
 * XRechnung specification identifier (version 3.0)
 */
export const XRECHNUNG_SPEC_ID = 'urn:cen.eu:en16931:2017#compliant#urn:xeinkauf.de:kosit:xrechnung_3.0';

/**
 * Default payment terms in days
 */
export const DEFAULT_PAYMENT_DAYS = 14;
